"use client"

import { formatFocusArea } from "./formatFocusArea"
import { FocalPointImageProps } from "../component/FocusedImage/FocusedImageMethods"
import { RegularImageProps } from "../utils/types/RegularImageProps"
import { FocusedImage } from "@/components/terra/component/FocusedImage/FocusedImage"
import { imageSizesObject } from "../component/FocusedImage/FocusedImageMethods"
import {
  IMAGE_QUALITY_MOBILE,
  cardSrc,
  CARD_SOURCES,
} from "@/lib/heroImageUtils"

export type FocusedOrRegularImageProps =
  | FocalPointImageProps
  | RegularImageProps
  | null

export const renderFocusedOrRegularImage = (
  image: FocusedOrRegularImageProps,
  imageSizes: imageSizesObject,
  className: string,
  quality = IMAGE_QUALITY_MOBILE,
  componentImagePriority?: "high" | "auto" | "low",
  isLCP: boolean = false,
) => {
  if (!image) return null
  if (typeof image === "object") {
    if ("focalPointImage" in image && image?.focalPointImage !== undefined) {
      return (
        <FocusedImage
          focalPointImage={image?.focalPointImage}
          alt={image?.alt || ""}
          className={`${className}`}
          quality={quality}
          imageSizes={imageSizes}
          fullHeightWrapper={true}
          lazyLoad={!isLCP}
          componentImagePriority={componentImagePriority}
        />
      )
    } else if (!("focalPointImage" in image)) {
      const focusParam = image?.focusArea
        ? formatFocusArea(image.focusArea)
        : null
      const baseUrl = image?.src || image?.url
      const iw = imageSizes.desktop?.width ?? CARD_SOURCES.bound.w
      const ih = imageSizes.desktop?.height ?? CARD_SOURCES.bound.h
      const imageUrl = baseUrl
        ? cardSrc(baseUrl, iw, ih, focusParam, quality)
        : null
      return (
        <>
          {imageUrl && (
            <img
              className={`${className}`}
              src={imageUrl}
              alt={image?.alt || ""}
              width={iw}
              height={ih}
              fetchPriority={componentImagePriority}
              loading={isLCP ? "eager" : "lazy"}
            />
          )}
        </>
      )
    }
  }
}
